/*global $, Mrt */
/**
 * Created by Tormi Talv <tormi.talv@ambientia.ee> on 2016-03-08 16:15.
 */
require('./bootstrap');
const {MrtRegApi} = require('./frontend/mrt-reg-api');

Mrt.$regApi = MrtRegApi;

Mrt.configDefaults = {};
Mrt.config = $.extend({}, Mrt.configDefaults, Mrt.config);

Mrt.__getSelect2DefaultSettings = (specific = {}, ajax = false) => {
    let select2DefaultSettings = {
        theme: 'm100',
        closeOnSelect: true,
        // allowHtml: true,
        allowClear: false,
        'width': '100%',
        language: {
            inputTooLong: function (args) {
                const overChars = args.input.length - args.maximum;

                let message;
                if (Mrt.config.country === 'EST') {
                    message = 'Sisesta ' + overChars + ' täht';
                    if (overChars !== 1) {
                        message += 'e';
                    }
                    message += ' vähem';
                } else if (Mrt.config.country === 'FIN') {
                    message = '' + overChars + ' kirjainta';
                    message += ' vähemmän';
                } else {
                    message = 'Insert ' + overChars + ' characters less';
                }

                return message;
            },
            inputTooShort: function (args) {
                const remainingChars = args.minimum - args.input.length;

                let message;
                if (Mrt.config.country === 'EST') {
                    message = 'Sisesta ' + remainingChars + ' täht';
                    if (remainingChars !== 1) {
                        message += 'e';
                    }
                    message += ' veel';
                } else if (Mrt.config.country === 'FIN') {
                    message = '' + remainingChars + ' kirjainta';
                    message += ' vielä';
                } else {
                    message = 'Insert ' + remainingChars + ' characters more';
                }

                return message;
            },
            loadingMore: function () {
                return Mrt.translations['Laen tulemusi...'];
            },
            maximumSelected: function (args) {
                let message = 'Saad vaid ' + args.maximum + ' tulemus';

                if (args.maximum === 1) {
                    message += 'e';
                } else {
                    message += 't';
                }

                message += ' valida';

                return message;
            },
            noResults: function () {
                return Mrt.translations['Tulemused puuduvad'];
            },
            searching: function () {
                return Mrt.translations['Otsin...'];
            },
            removeAllItems: function () {
                return Mrt.translations[`Eemalda kõik valitud`];
            }
        }
    };

    if (ajax === true) {
        select2DefaultSettings['minimumInputLength'] = 3;
        select2DefaultSettings['ajax'] = {
            type: 'GET',
            dataType: 'json',
            delay: 500 // wait 250 milliseconds before triggering the request
        };
    }

    return $.extend({}, select2DefaultSettings, specific);
};

Mrt.selectizeCompetitors = function () {
    $('select.selectize-remote-competitors').select2(
        this.__getSelect2DefaultSettings(
            {
                ajax: {
                    url: '/api/competitors-for-select',
                }
            },
            true
        )
    );
};

Mrt.selectizeDistances = function () {
    $('select.selectize-remote-distances').select2(
        this.__getSelect2DefaultSettings(
            {
                ajax: {
                    url: '/api/distances-for-select',
                }
            },
            true
        )
    );
};

Mrt.selectizeCalDist = function () {
    $('select.selectize-remote-caldist').select2(
        this.__getSelect2DefaultSettings(
            {
                ajax: {
                    url: '/api/caldist-for-select',
                }
            },
            true
        )
    );
};

Mrt.selectizeCalendarDate = function () {
    $('select.selectize-calendar-special').select2(
        {
            theme: 'm100',
            minimumResultsForSearch: Infinity
        }
    );
};

Mrt.latestNewsCount = 4;
Mrt.latestNewsLoadMore = function () {
    const $this = this;
    const $button = $('#news-view-latest-news-load-more');
    if ($button.length === 0) {
        return;
    }
    if ($this.latestNewsCount >= 40) {
        return;
    }

    $button.on('click', function () {
        // e.preventDefault();
        const $target = $('.news-view .news-stream');

        $.ajax(
            {
                url: '/api/more-news',
                type: 'GET',
                dataType: 'html',
                data: {
                    count: $this.latestNewsCount
                },
                error: function () {
                },
                success: function (result) {
                    $target.append($(result));
                    $('html, body').animate({scrollTop: $(document).height()}, 'slow');
                    $this.latestNewsCount += 4;
                }
            }
        );
    });
};
Mrt.mouseLastX = 0;
Mrt.mouseLastY = 0;
Mrt.activateSitehat = function () {
    const $sitehatWrapper = $('.main-wrapper');
    $('#sitehat-banner')
        .css('top', $sitehatWrapper.offset().top + 'px')
        .css('height', $sitehatWrapper.outerHeight(true) + 'px')
        .css('width', $sitehatWrapper.outerWidth(true) + 'px');
};

Mrt.activateDistanceSlider = function () {
    let slider = document.getElementById('distance-slider');
    if (!slider) {
        return;
    }

    let distMinLimit = document.getElementById('filter-dist-min-limit');
    let distMaxLimit = document.getElementById('filter-dist-max-limit');

    if (distMinLimit === distMaxLimit) {
        distMinLimit = 1;
        distMaxLimit = 150;
    }

    let inputs = [];
    inputs.push(document.getElementById('filter-dist-min'));
    inputs.push(document.getElementById('filter-dist-max'));

    noUiSlider.create(slider, {
        start: [inputs[0].value, inputs[1].value],
        connect: true,
        tooltips: [wNumb({decimals: 1}), wNumb({decimals: 1})],
        range: {
            'min': parseFloat(distMinLimit.value),
            'max': parseFloat(distMaxLimit.value)
        }
    });

    slider.noUiSlider.on('update', function (values, handle) {
        inputs[handle].value = values[handle];
    });
};

$(function () {
    // Regular dropdowns
    $('select.select2').select2(
        Mrt.__getSelect2DefaultSettings(
            {
                minimumResultsForSearch: Infinity,
            }
        )
    );
    $('select.select2-searchable').select2(
        Mrt.__getSelect2DefaultSettings(
            {
                minimumResultsForSearch: 10,
            }
        )
    );
    $('select.select2-multi').select2(
        Mrt.__getSelect2DefaultSettings(
            {
                closeOnSelect: false,
                minimumResultsForSearch: 10,
                templateResult: Mrt.multiSelectTpl
            }
        )
    );

    // Activate select2 dropdowns
    Mrt.selectizeCompetitors();
    Mrt.selectizeDistances();
    Mrt.selectizeCalDist();
    Mrt.selectizeCalendarDate();

    //Other init
    Mrt.latestNewsLoadMore();
    Mrt.activateSitehat();
    Mrt.activateDistanceSlider();

    $('.results-per-page-select').on('change', function () {
        window.location.href = setUrlParameter('per_page', this.value);
    });

    $('#link-other-distances').on('click', function () {
        const $otherDistances = $('#other-distances');
        if ($otherDistances.is(':visible')) {
            $otherDistances.hide();
            $(this).removeClass('active');

        } else {
            $otherDistances.show();
            $(this).addClass('active');
        }

        return false;
    });

    const $newsBodyImg = $('#news-view-body').find('img');
    $newsBodyImg.addClass('img-fluid');
    $newsBodyImg.css('max-width', '100%').css('height', 'auto');

    $('[data-toggle="popover"]').popover();
    $('.dropdown-toggle').dropdown();

    // coverpop
    if (Mrt.showPopupBanner) {
        $('.coverpop-ad-ad a').addClass('coverpop-ad-close-go');

        CoverPop.start(
            {
                coverId: 'coverpop-ad',       // set default cover id
                expires: 0.041666667, // 1h = 0,041666667 days                    // duration (in days) before it pops up again
                closeClassNoDefault: 'coverpop-ad-close',       // close if someone clicks an element with this class and prevent default action
                closeClassDefault: 'coverpop-ad-close-go',    // close if someone clicks an element with this class and continue default action
                openClassDefault: 'coverpop-ad-open',        // set class name added to HTML element when CoverPop is opened
                cookieName: 'marathon100_coverpop_ad',            // to change the plugin cookie name
                onPopUpOpen: function () {
                },          // on popup open callback function
                onPopUpClose: function () {
                },          // on popup close callback function
                forceHash: 'splash',               // hash to append to url to force display of popup (e.g. http://yourdomain.com/#splash)
                delayHash: 'go',                   // hash to append to url to delay popup for 1 day (e.g. http://yourdomain.com/#go)
                closeOnEscape: false,                    // close if the user clicks escape
                delay: 0,                       // set an optional delay (in milliseconds) before showing the popup
                hideAfter: null                    // set an optional time (in milliseconds) to autohide
            }
        );

        $('.coverpop-ad-close-go, .coverpop-ad-close').on('click', function () {
            CoverPop.close();
        });

    }

    // Profile tab select
    if (window.location.hash) {
        let $tabSelector = $(window.location.hash + '-tab');
        if ($tabSelector.length > 0) {
            $tabSelector.trigger('click');
        }
    }

    // Off-canvas
    $('[data-toggle="offcanvas"]').on('click', function () {
        $('.offcanvas-collapse').toggleClass('open');
    });

    $('.has-tooltip').tooltip();

    let $stickyContainer = $('#sticky-banners-news-container');
    if ($stickyContainer.length > 0) {
        $stickyContainer.css('height', $('.news-view .article').outerHeight() - $('#most-read-container').outerHeight());
        new StickySidebar('.sticky', {
            topSpacing: 80,
            bottomSpacing: 10,
            containerSelector: '#sticky-banners-news-container',
            innerWrapperSelector: '#sticky-banners-news-inner'
        });
    }
});

Mrt.multiSelectTpl = (state) => {
    if (!state.id) {
        return state.text;
    }

    return $(
        '<span class="option-with-checkbox"><span class="text">' + state.text + '</span></span>'
    );
};

let openRows = {};
Mrt.openResRow = (id) => {
    const selector = '#results-table .data-extra-' + id;
    if (openRows[id]) {
        console.log(selector, 'close');
        $(selector).hide();
        openRows[id] = false;
    } else {
        console.log(selector, 'open');
        $(selector).show();
        openRows[id] = true;
    }
};

function setUrlParameter(paramName, paramValue) {
    let url = window.location.href;
    const hash = location.hash;
    url = url.replace(hash, '');
    if (url.indexOf(paramName + '=') >= 0) {
        const prefix = url.substring(0, url.indexOf(paramName));
        let suffix = url.substring(url.indexOf(paramName));
        suffix = suffix.substring(suffix.indexOf('=') + 1);
        suffix = (suffix.indexOf('&') >= 0) ? suffix.substring(suffix.indexOf('&')) : '';
        url = prefix + paramName + '=' + paramValue + suffix;
    } else {
        if (url.indexOf('?') < 0) {
            url += '?' + paramName + '=' + paramValue;
        } else {
            url += '&' + paramName + '=' + paramValue;
        }
    }

    return url + hash;
}
